// @flow
import Price from "common/records/Price"
import type { ServicePackagePriceInput } from "mmb/records/bookingInput"
import type {
  SeatingAncillary,
  SeatingAncillaryItem,
  SeatsItem,
} from "../../../scenes/BookingAncillary/consts/types"

export type SeatsInputItem = {
  booked_seat: string,
  passenger_id: number,
  seat: string,
}

export type SeatingAncillaryItemInput = {
  option: "particular_seat" | "window" | "aisle" | "extra_leg_room" | "sit_together",
  price: ServicePackagePriceInput,
  segment_code: string,
  seats: Array<SeatsInputItem>,
}

export type SeatingAncillaryInput = Array<{
  extra_id: ?number,
  id: number,
  items: Array<SeatingAncillaryItemInput>,
}>

export function seatingAncillaryItemPrice(price: ServicePackagePriceInput): Price {
  return new Price({
    amount: Number(price.amount),
    base: Number(price.base),
    currency: price.currency,
    merchant: Number(price.merchant),
    service: Number(price.service),
    serviceFlat: Number(price.service_flat),
  })
}

export function seatingSeatsItem(seats: Array<SeatsInputItem>): Array<SeatsItem> {
  return seats.map(item => ({
    bookedSeat: item.booked_seat,
    passengerId: item.passenger_id,
    seat: item.seat,
  }))
}

export function seatingAncillaryItem(
  items: Array<SeatingAncillaryItemInput>,
): Array<SeatingAncillaryItem> {
  return items.map(item => ({
    option: item.option,
    price: seatingAncillaryItemPrice(item.price),
    segmentCode: item.segment_code,
    seats: seatingSeatsItem(item.seats),
  }))
}

export default function(ancillaryInput: SeatingAncillaryInput): SeatingAncillary {
  return ancillaryInput.map(item => ({
    id: item.id,
    extraId: item.extra_id,
    items: seatingAncillaryItem(item.items),
  }))
}
